<template>
    <div class="videoCarousel">
        <v-slide-group center-active show-arrows="mobile" v-model="activeDay">
            <v-slide-group-item v-for="src in linksList">
                <videoPlayer :src="src" />
            </v-slide-group-item>
        </v-slide-group>

        <div class="videoCarousel__tools">
            <div @click="prevSlide" class="videoCarousel__tools__prev icon-button small" :class="{ 'disabled': activeDay === 1 }">
                <img src="/img/default/chevron_left.svg" alt="">
            </div>
            <div @click="nextSlide" class="videoCarousel__tools__next icon-button small" :class="{ 'disabled': activeDay === linksList.length - 2 }">
                <img src="/img/default/chevron_right.svg" alt="">
            </div>
        </div>
    </div>
</template>

<style lang="scss" src="./styleForVSlider.scss"></style>
<style scoped lang="scss" src="./style.scss"></style>

<script src="./script.js"></script>
